import * as z from "zod/mini";

const INJECTION_RE = /[<>]|script|javascript:|--|\/\*|\x00/i;

// zod/mini has no method-style .refine(); z.refine() returns a check for .check().
const noInjection = () =>
  z.refine((val: unknown) => !INJECTION_RE.test(val as string), {
    message: "Invalid characters detected",
  });

export const secureString = (min = 1, max = 255) =>
  z.string().check(z.trim(), z.minLength(min, "Required"), z.maxLength(max), noInjection());

// Email format is validated before trim/lowercase, matching the classic chain's order.
export const secureEmail = () =>
  z.pipe(
    z.email("Enter a valid email address"),
    z.string().check(z.trim(), z.toLowerCase(), noInjection()),
  );
